export default __webpack_public_path__ + "static/business_cube_logo-ccf6174fa27b50f2697dcb399f1e67e1.png";